const PIXEL_ID = '912696691856874'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  if (window.fbq) {
    initialized = true
    window.fbq('track', 'PageView')
    return
  }

  // Bootstrap fbq queue
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  window.fbq = n
  window._fbq = n

  // Inject the Facebook events script safely
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const target =
    document.getElementsByTagName('script')[0] ||
    document.head ||
    document.body ||
    document.documentElement

  if (target && target.parentNode) {
    target.parentNode.insertBefore(script, target)
  } else if (document.head) {
    document.head.appendChild(script)
  } else {
    document.documentElement.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  initialized = true
}

export function trackAddToCart(data?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', data)
}
